<div class="cads-sparkline-summary">
  <div class="cads-sparkline-summary__top">
    <div class="cads-sparkline-summary__text">
      <div class="cads-sparkline-summary__text-grid">
        @for (row of config().leadingRows; track $index) {
          @if (row.leadingText) {
            <span class="cads-sparkline-summary__leading">{{ row.leadingText }}</span>
          }
          <span
            class="cads-sparkline-summary__trailing"
            [class.cads-sparkline-summary__trailing--full]="!row.leadingText"
            [class.cads-sparkline-summary__trailing--primary]="!!row.leadingText"
            [style.color]="!row.leadingText ? _accentColorVar() : null"
            >{{ row.trailingText }}</span>
        }
        @if (config().leadingRows.length === 0) {
          @let summary = config().summaryRow;
          @if (summary.leadingText) {
            <span class="cads-sparkline-summary__leading">{{ summary.leadingText }}</span>
          }
          <span
            class="cads-sparkline-summary__trailing"
            [class.cads-sparkline-summary__trailing--full]="!summary.leadingText"
            [style.color]="_accentColorVar()"
            >{{ summary.trailingText }}</span>
        } @else {
          @if (_showDivider()) {
            <hr class="cads-sparkline-summary__divider" />
          }
          @let summary = config().summaryRow;
          @if (summary.leadingText) {
            <span class="cads-sparkline-summary__leading">{{ summary.leadingText }}</span>
          }
          <span
            class="cads-sparkline-summary__trailing"
            [class.cads-sparkline-summary__trailing--full]="!summary.leadingText"
            [style.color]="_accentColorVar()"
            >{{ summary.trailingText }}</span>
        }
      </div>
    </div>
    <div class="cads-sparkline-summary__sparkline">
      <cads-sparkline-bit [config]="_sparklineConfig()" />
    </div>
  </div>
</div>
